import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { constants } from './fareTrendStyles';
import { dateComp } from './fareTrendsUtils';

class FareTrendsLineChart extends Component {
  static propTypes = {
    showMonth: PropTypes.bool,
    fareTrendsData: PropTypes.array,
    dividerWidth: PropTypes.number,
    lineHeight: PropTypes.number,
    svgHeight: PropTypes.number,
    maxHeightPercent: PropTypes.number,
    keyFrameAnimation: PropTypes.func,

    fareTrendWrapperClasses: PropTypes.string,
    fareTrendWrapperStyle: PropTypes.object,
    wrapperClasses: PropTypes.string,
    wrapperStyles: PropTypes.object,
    svgClasses: PropTypes.string,
    svgStyles: PropTypes.object,
    polyLineClasses: PropTypes.string,
    polyLineStyles: PropTypes.object,
    colors: PropTypes.object,

    dateTxtAttributes: PropTypes.object,
    circleAttributes: PropTypes.object,
    priceAttributes: PropTypes.object,
    lineAttributes: PropTypes.object,
    selectedDividerAttr: PropTypes.object,
    otherDividerAttr: PropTypes.object,

    checkin: PropTypes.object,
    selectOtherDate: PropTypes.func,
    selectedDate: PropTypes.string
  };

  static defaultProps = {
    ...constants,
    selectOtherDate: () => {}
  };

  constructor(props) {
    super(props);
    this.circleY = [];
    this.datePosUp = [];
    const { fareTrendsData, dividerWidth, keyFrameAnimation, polyLineStyles } = props;
    if (fareTrendsData.length) {
      const totalWidth = fareTrendsData.length * dividerWidth;
      polyLineStyles.strokeDasharray = totalWidth;
      keyFrameAnimation(totalWidth);
    }
  }

  componentDidMount() {
    this.scrollDivider();
  }

  generatePolyLinePoints() {
    const { fareTrendsData, dividerWidth } = this.props;
    let priceArray = fareTrendsData.map(fareObj => fareObj.price);
    this.maxPrice = Math.max.apply(null, priceArray);
    this.minPrice = Math.min.apply(null, priceArray);

    /* Max value will be 80% of the total height */
    const maxVal = (this.maxPrice * 100) / constants.maxHeightPercent;

    /* Reversing the price value to plot increasing value at the top */
    priceArray = priceArray.map(val => {
      const percent = (val / maxVal) * 100;
      return 100 - percent;
    });
    /* To Store the values of y-axis to place circle and to Draw Polyline */
    const polyLinePointArray = priceArray.map((val, index) => {
      this.circleY[index] = val;
      this.datePosUp[index] = val > 75;
      return index * dividerWidth + dividerWidth / 2 + ' ' + val;
    });
    this.points = polyLinePointArray.join(',');
  }

  findIndex = (fareObj, selectedDate, currentFareWidth) => {
    let indexToUse = 3;
    if (selectedDate) {
      indexToUse = 2;
      this.selectedDayWidth = currentFareWidth;
    }
    if (fareObj.price === this.maxPrice) {
      indexToUse = 1;
    } else if (fareObj.price === this.minPrice) {
      indexToUse = 0;
    }
    return indexToUse;
  };

  loadDivider = () => {
    const {
      fareTrendsData,
      dividerWidth,
      lineHeight,
      colors,
      lineAttributes,
      dateTxtAttributes,
      priceAttributes,
      circleAttributes,
      svgHeight,
      selectedDate = '',
      selectOtherDate,
      showMonth
    } = this.props;
    return fareTrendsData.map((fareObj, index) => {
      let rectAttributes = {};
      const currentFareWidth = dividerWidth / 2 + index * dividerWidth; // Position of current Element's Fare, Circle and Date
      const currentDividerWidth = index * dividerWidth; // Position of current Divider Line
      const isSelectedDate = selectedDate && selectedDate === fareObj.date;
      const indexToUse = this.findIndex(fareObj, isSelectedDate, currentFareWidth);
      const circleColor = colors.circleColor[indexToUse] || constants.colors.circleColor[1];
      const priceColor = colors.priceColor[indexToUse] || constants.colors.priceColor[0];
      const dateColor = colors.dateColor[indexToUse] || constants.colors.dateColor[0];
      const datePositionY = this.datePosUp[index]
        ? this.circleY[index] - 20
        : this.circleY[index] + 20;
      if (isSelectedDate) {
        rectAttributes = constants.selectedDividerAttr;
      } else {
        rectAttributes = constants.otherDividerAttr;
      }

      return (
        <g key={'divider_' + index}>
          <a onClick={() => selectOtherDate(fareObj.date)}>
            <rect
              x={currentFareWidth - dividerWidth / 2}
              y="0"
              width={dividerWidth}
              height={svgHeight}
              {...rectAttributes}
            ></rect>
            <text x={currentFareWidth} fill={dateColor} {...dateTxtAttributes}>
              {dateComp(fareObj.date, showMonth)}
            </text>
            <circle
              cx={currentFareWidth}
              cy={this.circleY[index]}
              stroke={colors.strokeColor}
              fill={circleColor}
              {...circleAttributes}
            ></circle>
            <text x={currentFareWidth} y={datePositionY} fill={priceColor} {...priceAttributes}>
              {'₹' + fareObj.price}
            </text>
            <line
              x1={currentDividerWidth}
              y1={0}
              x2={currentDividerWidth}
              y2={lineHeight}
              {...lineAttributes}
            ></line>
          </a>
        </g>
      );
    });
  };

  /* Horizontally Scroll to the Selected Divider on click */
  scrollDivider = () => {
    const { dividerWidth } = this.props;
    if (this.selectedDayWidth && this.refs.fareTrend) {
      /* selectedDayWidth provides circle's width of selectedDay. */
      /* 2*dividerwidth is done to include two show two more fares before selected fare. */
      this.refs.fareTrend.scrollTo(this.selectedDayWidth - 2 * dividerWidth, 0);
    }
  };

  render() {
    const {
      svgStyles,
      svgClasses,
      polyLineStyles,
      polyLineClasses,
      fareTrendsData,
      dividerWidth,
      wrapperStyles,
      wrapperClasses,
      fareTrendWrapperClasses,
      fareTrendWrapperStyle,
      keyFrameAnimation
    } = this.props;
    if (fareTrendsData.length === 0) {
      return null;
    }
    this.generatePolyLinePoints();
    const svgWidth = fareTrendsData.length * dividerWidth;
    return (
      <div className={fareTrendWrapperClasses} style={{ ...fareTrendWrapperStyle }}>
        <div id="fareTrend" ref="fareTrend" className={wrapperClasses} style={{ ...wrapperStyles }}>
          <svg className={svgClasses} style={{ ...svgStyles, width: svgWidth }}>
            <polyline
              points={this.points}
              className={polyLineClasses}
              style={{ ...polyLineStyles }}
            />
            {this.loadDivider()}
            {keyFrameAnimation(svgWidth, this.selectedDayWidth)}
          </svg>
        </div>
      </div>
    );
  }
}

export default FareTrendsLineChart;
